<template>
  <div class="grid grid-cols-2 tablet-h:grid-cols-4 gap-[22px]">
    <div v-for="attribute in props.attributes" :key="attribute.key">
      <div class="text-[12px] text-gray-500 leading-[20px] mb-1.5">
        {{ attribute.key }}
      </div>
      <div class="leading-[20px]">
        {{ parseAttribute(attribute.value) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Attribute } from '@/shared/graphql/router/graphql'
import { formatTimestamp } from '@/shared/utils/datetime'
import { formatNumber } from '@/shared/utils/number'

const props = defineProps<{
  attributes: Attribute[]
}>()

const parseAttribute = (value: string | number) => {
  const normalized = String(value).trim()

  if (
    typeof value === 'string' &&
    value.length === 10 &&
    /^\d+$/.test(value) &&
    !isNaN(parseInt(value)) &&
    new Date(parseInt(value))
  ) {
    return formatTimestamp(parseInt(`${value}000`))
  }

  if (typeof value === 'number') return formatNumber(value)

  if (
    normalized &&
    /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/.test(normalized) &&
    !Number.isNaN(Number(normalized))
  ) {
    return formatNumber(normalized)
  }

  return value
}
</script>
